import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import parseISO from 'date-fns/parseISO'
import { ActivityRecord, ActivityRecordApi } from '@/api/models/activityRecord'
import { ObjectiveWorkflowId } from '@/api/models/aggregate'

type ActivityRecordsState = {
  activityRecords: ActivityRecord[]
}

const initialState: ActivityRecordsState = {
  activityRecords: [],
}

export const fetchMyActivityRecordsAsync = createAsyncThunk<
  ActivityRecord[],
  { objectiveWorkflowId: ObjectiveWorkflowId; queries: Record<string, any> }
>('fetchMyActivityRecordsAsync/fetch', ({ objectiveWorkflowId, queries }) => {
  return ActivityRecordApi.query({ objectiveWorkflowId, queries })
})

export const activityRecordsSlice = createSlice({
  name: 'activityRecords',
  initialState,
  reducers: {
    reset(state) {
      state.activityRecords = []
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchMyActivityRecordsAsync.fulfilled, (state, action) => {
      state.activityRecords = action.payload.sort(
        (a, b) => parseISO(b.finished).valueOf() - parseISO(a.finished).valueOf(),
      )
    })
  },
})

export const { reset } = activityRecordsSlice.actions

export default activityRecordsSlice.reducer
